<div class="complete-order-dialog"> 
  <h2 class="dialog-title">{{ 'COMPLETE_ORDER.TEXT' | translate }}</h2>
  
  <form [formGroup]="fileForm" (ngSubmit)="onSubmit()" class="form-container">
    <!-- Actual Delivered Quantity Input -->
    <div class="form" class="flex gap-3">
      <mat-form-field appearance="outline" class="flex-2">
        <mat-label>{{ 'DELIVERED_QUANTITY.TEXT' | translate }}</mat-label>
        <input
          matInput
          type="number"
          formControlName="actualDeliveredQuantity"
        />
        <mat-error *ngIf="fileForm.get('actualDeliveredQuantity').hasError('required')">
          {{ 'REQUIRED.TEXT' | translate }}
        </mat-error>
        <mat-error *ngIf="fileForm.get('actualDeliveredQuantity').hasError('max')">
          The quantity loaded cannot be exceeded : {{ maxQuantity }}
        </mat-error>
        <mat-error *ngIf="fileForm.get('actualDeliveredQuantity').hasError('min')">
          Quantity must be greater than 0
        </mat-error>
      </mat-form-field>
      <p class="pt-3 px-6 flex-1">{{this.itemUOM}}</p>

      <!-- <p class="quantity-info">
        {{ 'MAX_ALLOWED_QUANTITY.TEXT' | translate }}: {{ maxQuantity }}
      </p> -->
    </div>

    <!-- Delivery Number (optional) -->
    <div class="form">
      <mat-form-field appearance="outline" class="flex-1">
        <mat-label>{{ 'DELIVERY_NUMBER.TEXT' | translate }}</mat-label>
        <input
          matInput
          type="text"
          formControlName="deliveryNumber"
        />
      </mat-form-field>
    </div>

    <!-- File Upload Section -->
    <div class="form">
      <label class="file-upload-label" for="file-input">
        <mat-icon svgIcon="mat:attach_file"></mat-icon> {{ 'CHOOSE_DELIVERED_IMAGE.TEXT' | translate }}
      </label>
      <input 
        id="file-input"
        type="file" 
        (change)="onFileSelected($event)" 
        #fileInput 
        hidden 
      />
      <p class="file-name">
        {{ fileName }}
      </p>
    </div>

    <!-- Submit and Cancel Buttons -->
    <div class="button-group">
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="!fileForm.valid || isLoading">
        {{ 'SUBMIT.TEXT' | translate }}
      </button>
      <button
        mat-button
        type="button"
        (click)="onCancel()">
        {{ 'CANCEL.TEXT' | translate }}
      </button>
    </div>
  </form>
</div>
